import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const loginHandle = createAsyncThunk('login', async body => {
	const response = await axios.post('/manage/common/login', JSON.stringify(body));
	
	return response;
})

export const resetHandle = createAsyncThunk('reset', async body => {
	const response = await axios.put('/manage/common/reset', JSON.stringify(body));
	
	return response;
})

export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        authorization: null,
        account: null,
		needChange: null
    },
    reducers: {
		resetState: (state, props) => {
			state.authorization = null;
			state.account = null;
			state.needChange = null;
			localStorage.removeItem('persist:root');
			localStorage.removeItem('authorization');
		}
	},
    extraReducers: builder => {
        builder.addCase(loginHandle.fulfilled, (state, {payload: {token, account, needChange}}) => {
			state.authorization = token;
			state.account = account;			
			state.needChange = needChange;
			localStorage.setItem('authorization', token);
		})
		builder.addCase(resetHandle.fulfilled, (state, { payload, payload: { account, token } }) => {
			state.authorization = token;
			state.account = account;			
			localStorage.setItem('authorization', token);
		})
    }
})

export const { resetState } = loginSlice.actions;
export default loginSlice.reducer;
